import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import { addRequest } from "../modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    loadingSave: state.offerRequestReducer.loadingSave,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      addRequest,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
